// extracted by mini-css-extract-plugin
export var grid = "caseStudyGrid-module--grid--uatzl";
export var tile = "caseStudyGrid-module--tile--BmIMW";
export var image = "caseStudyGrid-module--image--TkkC9";
export var content = "caseStudyGrid-module--content--eGT1V";
export var header = "caseStudyGrid-module--header--O-4t4";
export var large = "caseStudyGrid-module--large--m9tgD";
export var column = "caseStudyGrid-module--column--TzGGQ";
export var fadeIn = "caseStudyGrid-module--fadeIn--1MH2F";
export var slideIn = "caseStudyGrid-module--slideIn--o-kM3";